import PropTypes from "prop-types"
import { DATE } from "helpers/shapes"

export default PropTypes.shape({
  values: PropTypes.objectOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    formatter: PropTypes.func,
    dates: PropTypes.shape({
      date: DATE.isRequired,
      value: PropTypes.number.isRequired,
    }).isRequired,
  })),
})
